import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const UnlockIcon = ({ size = defaultSize }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M6 9C6 5.68629 8.68629 3 12 3C13.9634 3 15.7065 3.94409 16.7995 5.39884C17.1312 5.84039 17.0422 6.46726 16.6007 6.79901C16.1591 7.13075 15.5322 7.04174 15.2005 6.60019C14.469 5.6266 13.3078 5 12 5C9.79086 5 8 6.79086 8 9H18C19.6569 9 21 10.3431 21 12V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V12C3 10.3431 4.34315 9 6 9ZM6 11C5.44772 11 5 11.4477 5 12V18C5 18.5523 5.44772 19 6 19H18C18.5523 19 19 18.5523 19 18V12C19 11.4477 18.5523 11 18 11H6ZM12 13C12.5523 13 13 13.4477 13 14V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V14C11 13.4477 11.4477 13 12 13Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

UnlockIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(UnlockIcon);
